export { default as TextAreaAutoGrow } from './TextAreaAutoGrow.vue';
